/* ===== ContainVive ===== */

/* --- Analítica: eventos propios ---
   Se publican en Shopify (píxeles personalizados, Google & YouTube, Meta...)
   y en dataLayer si algún día instalas Google Tag Manager. */
function cvTrack(nombre, datos) {
  datos = datos || {};
  try {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(nombre, datos);
    }
  } catch (e) {}
  try {
    window.dataLayer = window.dataLayer || [];
    var ev = { event: nombre };
    for (var k in datos) { if (Object.prototype.hasOwnProperty.call(datos, k)) ev[k] = datos[k]; }
    window.dataLayer.push(ev);
  } catch (e) {}
}
document.addEventListener('click', function (e) {
  var el = e.target.closest ? e.target.closest('[data-track]') : null;
  if (el) cvTrack(el.getAttribute('data-track'), { origen: el.getAttribute('data-origen') || '' });
});

/* --- Sombra de la barra al hacer scroll --- */
(function () {
  var nav = document.getElementById('nav');
  if (!nav) return;
  function onScroll() { nav.classList.toggle('scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* --- Animación de entrada --- */
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('visible'); });
    return;
  }
  var ro = new IntersectionObserver(function (entries) {
    entries.forEach(function (x) {
      if (x.isIntersecting) { x.target.classList.add('visible'); ro.unobserve(x.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function (el) { ro.observe(el); });
})();

/* --- Cambio de línea: Containers / Prefab --- */
function setLinea(linea, silencioso) {
  linea = linea === 'containers' ? 'containers' : 'prefab';
  document.body.setAttribute('data-linea', linea);
  document.querySelectorAll('.lt-btn, .dt-btn').forEach(function (b) {
    b.setAttribute('aria-pressed', b.getAttribute('data-linea') === linea ? 'true' : 'false');
  });
  if (!silencioso) {
    cvTrack('cambio_linea', { linea: linea });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
setLinea(document.body.getAttribute('data-linea'), true);

/* --- Menú móvil --- */
function toggleDrawer(abrir) {
  var d = document.getElementById('navDrawer');
  var b = document.getElementById('hamburger');
  if (!d) return;
  var open = typeof abrir === 'boolean' ? abrir : !d.classList.contains('open');
  d.classList.toggle('open', open);
  if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  document.body.style.overflow = open ? 'hidden' : '';
}
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggleDrawer(false); });
window.addEventListener('resize', function () { if (window.innerWidth > 1240) toggleDrawer(false); });

/* --- Containers: precio con / sin instalación --- */
function toggleMontaje(modelo, base) {
  var cb = document.getElementById('toggle-' + modelo);
  var el = document.getElementById('precio-' + modelo);
  var nota = document.getElementById('nota-' + modelo);
  var total = cb && cb.checked ? base + 20000 : base;
  if (el) el.innerHTML = 'Desde ' + total.toLocaleString('es-ES') + ' €<span class="precio-iva"> + IVA</span>';
  if (nota) nota.textContent = cb && cb.checked ? 'precio con instalación incluida' : 'solo estructura y traslado';
}

/* --- Botón "Pedir presupuesto" de cada modelo --- */
function irContacto(modelo) {
  var prefab = document.body.getAttribute('data-linea') !== 'containers';
  var sel = document.getElementById(prefab ? 'pf-modelo' : 'f-modelo');
  if (sel) {
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].text.indexOf(modelo) === 0) { sel.selectedIndex = i; break; }
    }
  }
  cvTrack('presupuesto_click', { modelo: modelo, linea: prefab ? 'prefab' : 'containers' });
  var dest = document.getElementById(prefab ? 'contacto-prefab' : 'contacto');
  if (dest) dest.scrollIntoView({ behavior: 'smooth' });
}

/* --- Nombres de las casas Prefab (12/10/2026) y su código de fábrica ---
   El cliente solo ve el nombre. El código sirve para encontrar la reserva aunque en
   Shopify la variante se llame todavía «HG 1 – …», y sale en el email del contacto. */
var CV_CODIGOS = {
  'Brisa 24': 'HG 1', 'Levante 44': 'HG 2', 'Poniente 66': 'HG 3', 'Garbí 70': 'HG 4',
  'Aitana 102': 'HF-1', 'Bernia 128': 'HF-2', 'Montgó 128': 'HF-3', 'Puig Campana 192': 'HF-4',
  'Vega 31': 'TR-1', 'Lyra 45': 'TR-2', 'Orión 89': 'TE-1'
};
function codigoDe(modelo) {
  for (var n in CV_CODIGOS) {
    if (Object.prototype.hasOwnProperty.call(CV_CODIGOS, n) && String(modelo).indexOf(n) === 0) return CV_CODIGOS[n];
  }
  return '';
}

/* --- Reserva online: lleva al pago de Shopify con el modelo elegido --- */
function reservar(modelo) {
  var mapa = window.CV_RESERVA || {};
  var id = null, cod = codigoDe(modelo);
  for (var k in mapa) {
    if (!Object.prototype.hasOwnProperty.call(mapa, k)) continue;
    if (k.indexOf(modelo) === 0 || (cod && k.indexOf(cod) === 0)) { id = mapa[k]; break; }
  }
  if (!id) { irContacto(modelo); return; }   // si la reserva no está disponible, al formulario
  cvTrack('reserva_click', { modelo: modelo, linea: document.body.getAttribute('data-linea') || 'prefab' });
  window.location.href = '/cart/' + id + ':1';
}

/* --- Formularios: validación con mensajes claros --- */
var CV_ERRORES = {
  nombre: 'Escribe tu nombre.',
  telefono: 'Escribe un teléfono válido, por ejemplo 600 123 456.',
  email: 'Revisa el email, por ejemplo nombre@gmail.com.'
};

function telefonoValido(t) {
  var limpio = t.replace(/[\s.\-()]/g, '');
  return /^(\+34|0034)?[6789]\d{8}$/.test(limpio) || /^\+\d{9,15}$/.test(limpio);
}

function mostrarError(id, mensaje) {
  var input = document.getElementById(id);
  var err = document.getElementById(id + '-err');
  if (!input) return;
  input.classList.add('is-invalid');
  input.setAttribute('aria-invalid', 'true');
  if (err) { err.textContent = mensaje; err.hidden = false; }
}

function limpiarError(id) {
  var input = document.getElementById(id);
  var err = document.getElementById(id + '-err');
  if (!input) return;
  input.classList.remove('is-invalid');
  input.removeAttribute('aria-invalid');
  if (err) { err.textContent = ''; err.hidden = true; }
}

['f-', 'pf-'].forEach(function (pre) {
  ['nombre', 'telefono', 'email'].forEach(function (campo) {
    var el = document.getElementById(pre + campo);
    if (el) el.addEventListener('input', function () { limpiarError(pre + campo); });
  });
});

function leerForm(prefijo) {
  function v(id) { var el = document.getElementById(prefijo + id); return el ? el.value.trim() : ''; }
  return { nombre: v('nombre'), telefono: v('telefono'), email: v('email'), modelo: v('modelo'), mensaje: v('mensaje') };
}

function validarForm(prefijo, d) {
  var primero = null;
  ['nombre', 'telefono', 'email'].forEach(function (c) { limpiarError(prefijo + c); });
  if (d.nombre.length < 2) { mostrarError(prefijo + 'nombre', CV_ERRORES.nombre); primero = primero || prefijo + 'nombre'; }
  if (!telefonoValido(d.telefono)) { mostrarError(prefijo + 'telefono', CV_ERRORES.telefono); primero = primero || prefijo + 'telefono'; }
  if (d.email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(d.email)) { mostrarError(prefijo + 'email', CV_ERRORES.email); primero = primero || prefijo + 'email'; }
  if (primero) { document.getElementById(primero).focus(); return false; }
  return true;
}

function textoForm(linea, d) {
  return '¡Hola! Me interesa pedir presupuesto en ContainVive (' + linea + ').\n\n'
    + '👤 ' + d.nombre + '\n'
    + '📞 ' + d.telefono + '\n'
    + (d.email ? '📧 ' + d.email + '\n' : '')
    + '🏡 Modelo: ' + d.modelo
    + (d.mensaje ? '\n\n💬 ' + d.mensaje : '');
}

/* Abre WhatsApp con el mensaje, te envía el contacto por email y lleva a Gracias */
function enviarAWhatsApp(prefijo, lineaTexto, lineaClave) {
  var d = leerForm(prefijo);
  if (!validarForm(prefijo, d)) return;
  var texto = textoForm(lineaTexto, d);
  try { sessionStorage.setItem('cv-ultimo-form', JSON.stringify({ nombre: d.nombre, texto: texto, linea: lineaClave })); } catch (e) {}
  cvTrack('formulario_enviado', { linea: lineaClave, modelo: d.modelo });
  window.open('https://wa.me/34621016067?text=' + encodeURIComponent(texto), '_blank');
  if (!enviarContactoPorEmail(d, lineaTexto)) window.location.href = '/pages/gracias';
}

/* Rellena el formulario de contacto de Shopify (oculto) y lo envía.
   Shopify manda el email a containvive@gmail.com y redirige a /pages/gracias. */
function enviarContactoPorEmail(d, lineaTexto) {
  var f = document.getElementById('cv-lead-form');
  if (!f) return false;
  function set(id, v) { var el = document.getElementById(id); if (el) el.value = v; }
  set('lead-nombre', d.nombre);
  set('lead-email', d.email || 'containvive@gmail.com');
  set('lead-telefono', d.telefono);
  set('lead-linea', lineaTexto);
  set('lead-modelo', d.modelo);
  set('lead-mensaje',
    'Nuevo contacto desde la web (' + lineaTexto + ')\n\n'
    + 'Nombre: ' + d.nombre + '\n'
    + 'Teléfono: ' + d.telefono + '\n'
    + 'Email: ' + (d.email || 'no lo ha dejado') + '\n'
    + 'Modelo: ' + d.modelo + (codigoDe(d.modelo) ? ' (' + codigoDe(d.modelo) + ')' : '') + '\n'
    + 'Mensaje: ' + (d.mensaje || '(sin mensaje)') + '\n\n'
    + 'También se le ha abierto WhatsApp con este mensaje. Si no te escribe, llámale.');
  try { f.submit(); return true; } catch (e) { return false; }
}

/* Si Shopify vuelve a la portada tras enviar el contacto, pasar a Gracias */
(function () {
  if (/[?&]contact_posted=/.test(location.search) && !/\/pages\/gracias/.test(location.pathname)) {
    location.replace('/pages/gracias');
  }
})();

function enviarFormulario() { enviarAWhatsApp('f-', 'Containers', 'containers'); }
function enviarFormularioPrefab() { enviarAWhatsApp('pf-', 'Línea Prefab', 'prefab'); }

/* --- Enlace "Preferencias de cookies" (banner de Shopify) --- */
(function () {
  var li = document.querySelector('.cvf-cookies');
  if (!li) return;
  var intentos = 0;
  (function comprobar() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { li.hidden = false; return; }
    if (intentos++ < 20) setTimeout(comprobar, 500);
  })();
})();

/* --- Calculadora de precio Prefab ---
   Los modelos con data-precio muestran su precio. El resto (A-Frame u otro
   tamaño) muestra la horquilla de 500–700 €/m². */
var CV_CALC = { min: 500, max: 700, m2min: 20, m2max: 250 };

function cvEuros(n) { return Math.round(n).toLocaleString('es-ES') + ' €'; }

function calcEstado() {
  var sel = document.getElementById('calc-modelo');
  var num = document.getElementById('calc-m2');
  var m2 = parseInt(num.value, 10);
  if (isNaN(m2)) m2 = CV_CALC.m2min;
  m2 = Math.min(CV_CALC.m2max, Math.max(CV_CALC.m2min, m2));
  var opt = sel.options[sel.selectedIndex];
  var codigo = sel.value && sel.value !== 'otro' ? sel.value : '';
  var nombre = codigo ? opt.text.split(' · ')[0] : '';
  var precio = parseInt(opt.getAttribute('data-precio') || '', 10);
  return {
    m2: m2, codigo: codigo, nombre: nombre,
    precio: isNaN(precio) ? 0 : precio,
    min: m2 * CV_CALC.min, max: m2 * CV_CALC.max,
    nota: opt.getAttribute('data-nota') || ''
  };
}

function calcPintar() {
  var e = calcEstado();
  var fijo = e.precio > 0;
  document.getElementById('calc-label').textContent = fijo ? 'Precio' : 'Precio orientativo';
  document.getElementById('calc-min').textContent = cvEuros(fijo ? e.precio : e.min);
  document.getElementById('calc-max').textContent = fijo ? '' : cvEuros(e.max);
  document.getElementById('calc-sep').hidden = fijo;
  document.getElementById('calc-max').hidden = fijo;
  document.getElementById('calc-detalle').textContent = fijo
    ? e.codigo + ' m²'
    : e.m2 + ' m² × 500–700 €/m²';
  var rango = document.getElementById('calc-rango');
  rango.style.setProperty('--p', ((e.m2 - CV_CALC.m2min) / (CV_CALC.m2max - CV_CALC.m2min) * 100) + '%');
  var nota = document.getElementById('calc-nota');
  nota.textContent = e.nota; nota.hidden = !e.nota;
  var btn = document.getElementById('calc-reservar');
  btn.disabled = !e.codigo;
  btn.textContent = e.codigo ? 'Reservar ' + e.codigo + ' por 500 €' : 'Elige un modelo para reservar';
}

function calcReservar() {
  var e = calcEstado();
  if (e.codigo) reservar(e.codigo);
}

function calcPresupuesto() {
  var e = calcEstado();
  var sel = document.getElementById('pf-modelo');
  if (sel) {
    for (var i = 0; i < sel.options.length; i++) {
      var t = sel.options[i].text;
      if (e.codigo ? t.indexOf(e.codigo) === 0 : t.indexOf('No lo sé') === 0) { sel.selectedIndex = i; break; }
    }
  }
  var msg = document.getElementById('pf-mensaje');
  if (msg && !msg.value.trim()) {
    msg.value = e.precio
      ? 'Me interesa ' + e.nombre + ' (' + e.m2 + ' m², ' + cvEuros(e.precio) + ' + IVA).'
      : 'Me interesa ' + (e.nombre || 'una casa') + ' de unos ' + e.m2 + ' m² (estimación ' + cvEuros(e.min) + ' – ' + cvEuros(e.max) + ' + IVA).';
  }
  cvTrack('presupuesto_click', { modelo: e.codigo || 'otro', origen: 'calculadora', m2: e.m2 });
  var dest = document.getElementById('contacto-prefab');
  if (dest) dest.scrollIntoView({ behavior: 'smooth' });
}

(function () {
  var sel = document.getElementById('calc-modelo');
  if (!sel) return;
  var rango = document.getElementById('calc-rango');
  var num = document.getElementById('calc-m2');
  var t = null;
  function registrar() {
    clearTimeout(t);
    t = setTimeout(function () { var e = calcEstado(); cvTrack('calculadora_uso', { modelo: e.codigo || 'otro', m2: e.m2 }); }, 1200);
  }
  function metrosCambiados(valor) {
    var opt = sel.options[sel.selectedIndex];
    var fijo = opt.getAttribute('data-m2');
    if (fijo && String(valor) !== fijo) sel.value = 'otro';
    calcPintar(); registrar();
  }
  sel.addEventListener('change', function () {
    var m2 = sel.options[sel.selectedIndex].getAttribute('data-m2');
    if (m2) { num.value = m2; rango.value = m2; }
    calcPintar(); registrar();
  });
  rango.addEventListener('input', function () { num.value = rango.value; metrosCambiados(rango.value); });
  num.addEventListener('input', function () {
    var v = parseInt(num.value, 10);
    if (!isNaN(v) && v >= CV_CALC.m2min && v <= CV_CALC.m2max) { rango.value = v; metrosCambiados(v); }
  });
  num.addEventListener('change', function () {
    var e = calcEstado(); num.value = e.m2; rango.value = e.m2; metrosCambiados(e.m2);
  });
  calcPintar();
})();

/* --- Preguntas frecuentes: registrar qué se abre --- */
document.querySelectorAll('.faq-item').forEach(function (d) {
  d.addEventListener('toggle', function () {
    if (d.open) cvTrack('faq_abierta', { pregunta: d.querySelector('summary').textContent.trim() });
  });
});
